module.exports = __webpack_public_path__ + "fonts/Kinetika-BlackItalic.7d68f1d6.woff";